import RoundImage from './RoundImage'

export default RoundImage
